import type { ListBuilderList } from '../../../types';
import { createStandardOrderColumns } from '../columns';
import {
	ORDER_MOBILE_CARD_CONFIG,
	ORDER_REQUIRED_FIELDS,
	SALES_REP_FILTER_RULES,
} from '../shared';

/**
 * Abandoned Carts list configuration
 * Unsubmitted orders with no recent activity that may need follow-up
 *
 * PD-13314: "abandoned" is defined by LAST MODIFIED date, not creation
 * date — a cart the customer (or a rep) is still actively updating is not
 * abandoned, no matter how old it is. A cart touched today drops out of
 * this list (and shows in Today's Carts / Today's Web Carts instead); it
 * re-surfaces tomorrow if it goes untouched. This matches the abandoned-
 * cart notification job, which has always keyed off last-modified.
 */
export const abandonedCartsList: ListBuilderList = {
	id: 'abandoned-carts',
	cacheTTL: 600000,
	name: 'Abandoned Carts',
	type: 'default',
	active: true,
	sortOrder: 5,
	requiredFeature: 'order-entry',
	columns: createStandardOrderColumns(),
	mobileCardConfig: ORDER_MOBILE_CARD_CONFIG,
	description:
		'Unsubmitted orders with no recent activity that may need follow-up',
	defaultSortId: 'column-dates-desc',
	requiredFields: ORDER_REQUIRED_FIELDS,
	filterRules: {
		...SALES_REP_FILTER_RULES,
		orderModifiedDateRange: {
			defaultValue: [
				{
					id: 'until-yesterday',
					label: 'Until Yesterday',
					data: {
						startDate: null,
						endDate: '{{DATE:-1d}}',
					},
				},
			],
		},
		orderStatus: {
			defaultValue: [
				{
					id: '1',
					label: 'Unsubmitted',
				},
			],
		},
		orderOrigin: {
			defaultValue: [
				{
					id: '1',
					label: 'CRM',
				},
				{
					id: '3',
					label: 'E-Commerce',
				},
			],
		},
	},
};
